import { useEffect, useState } from 'react'

export interface TargetProductClass {
  id: number
  name: string
  description: string
}

export const useTargetProductClassesData = (targetClasses: Array<string>) => {
  const [targetProductClasses, setTargetProductClasses] = useState<
    TargetProductClass[]
  >([])

  useEffect(() => {
    // From array To TargetProductClasses
    const trgProductClasses: Array<TargetProductClass> = []

    let idx = 0
    targetClasses.forEach((s) => {
      const targetProductClass: TargetProductClass = {
        id: idx,
        name: s,
        description: s,
      }
      trgProductClasses.push(targetProductClass)
      idx += 1
    })
    setTargetProductClasses(trgProductClasses)
  }, [targetClasses])

  return { targetProductClasses }
}
